import { render, staticRenderFns } from "./BindOptions.vue?vue&type=template&id=31a31626&scoped=true&"
import script from "./BindOptions.vue?vue&type=script&lang=js&"
export * from "./BindOptions.vue?vue&type=script&lang=js&"
import style0 from "./BindOptions.vue?vue&type=style&index=0&id=31a31626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a31626",
  null
  
)

export default component.exports